const PathUtils = {
  /**
   * Get url for routing location
   * @param  {string} segment a page resource
   * @return {string} The given path with appended websiteBaseDirectory at the beginging.
   */
  getPageUrl(segment) {
    return `/${segment}`;
  },
  /**
   * Get Relative Path by adding websiteBaseDirectory to any given path
   * @param  {string} path a relative path
   * @return {string} The given path with appended websiteBaseDirectory at the beginging.
   */
  getPath(path) {
    if (path && path.indexOf('http') >= 0) {
      return path;
    }

    if (!path) {
      console.warn('No path set for asset');
      return undefined;
    }

    return path;
  },
};

export default PathUtils;
